"use client";
import type React from "react";
import { useState } from "react";
import { CopyButton } from "./copy-button";

interface CopyableTextProps {
  text: string;
  className?: string;
  textClassName?: string;
  alwaysShowCopyButton?: boolean;
}

export const CopyableText: React.FC<CopyableTextProps> = ({
  text,
  className = "",
  textClassName = "",
  alwaysShowCopyButton = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`relative inline-flex items-center group ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className={`${textClassName}`}>{text}</span>
      <div
        className={`ml-1 transition-opacity ${isHovered || alwaysShowCopyButton ? "opacity-100" : "opacity-0"}`}
      >
        <CopyButton text={text} />
      </div>
    </div>
  );
};
